import _ from "underscore"
import TemplateView from '../../../TemplateView'
import {WeekApprovalStatus} from 'constants'
import SimpleTooltip from '../../../SimpleTooltip'
import $ from 'jquery'
import messageResource from '../../../messageResource'


export default class FilterDialog extends TemplateView {
    templateHtml() {
       return "<div class='filterDialogTitle'><%=filterDialogTitle%></div>" +
        "<div class='controlsContainer'>" +
        "   <table>" +
        "       <tr>" +
        "           <td class='controlLabel'>" +
        "               <div class='filterDialogLabel cpSelectorLabel'>" +
        "                   <%-Customer%><wbr>/<%-Project%>" +
        "               </div>" +
        "           </td>" +
        "           <td class='cPSelectorCell'>" +
        "               <div id = 'cpSelector' class='cpSelector'/>" +
        "           </td>" +
        "       </tr>" +
        "       <tr>" +
        "           <td class='controlLabel'>" +
        "               <div class='filterDialogLabel ttStatusLabel'>" +
        "                   <%=filterDialogTTStatus%>" +
        "               </div>" +
        "           </td>" +
        "           <td class='ttStatus'>" +
        "                <%for(var i = 0; i < checkboxes.length; i++){ var labelId = 'viewTTStatusCheckboxId_' + i;%>" +
        "                    <div>" +
        "                        <table><tr>" +
        "                            <td valign='top'><input type='checkbox' id='<%=labelId%>' class='<%=checkboxes[i].cls%>'></td>" +
        "                            <td valign='top' style='padding: 4px 0 0 3px;'>" +
        "                                <label for='<%=labelId%>' class='text'><%=messageResource.getMessage(checkboxes[i].labelKey)%></label>" +
        "                            </td>" +
        "                        </tr></table>" +
        "                    </div>" +
        "                <%}%>" +
        "           </td>" +
        "       </tr>" +
        "    </table>" +
        "</div>" +
        "<div class='buttonsPanel'>" +
        "   <input type='button' id='cancelFilterEdit' class='cancelFilterEdit' value='<%=filterCancel%>'/>" +
        "   <input type='button' id='applyFilterEdit' class='applyFilterEdit' value='<%=filterApply%>'/>" +
        "   <div class='errorMessage'></div>" +
        "</div>"
    }

    afterRender() {
        this.$approved = this.find(".showApproved");
        this.$ready = this.find(".showReady");
        this.$notReadyAndRejected = this.find(".showNotReadyAndRejected");

        this.autoApprovedTooltip = new SimpleTooltip({
            text: messageResource.getMessage('view_tt.filter.tooltip.auto_approved'),
        }).init($('body'))
        this.autoApprovedTooltip.subscribeToMouseEvents(this.find('.ttStatus'))
        this.autoApprovedTooltip.disable()
    }

    messageKeys() {
        return {
            Customer: "common.Customer",
            Project: "common.Project",
            filterDialogTitle: "view_tt.filter.dialog.title",
            filterDialogTTStatus: "view_tt.filter.dialog.tt_status.label",
            filterApply: "common.approvers_dialog.apply",
            filterCancel: "common.approvers_dialog.cancel"
        }
    }

    templateModel() {
        return {
            checkboxes: [
                {cls: "showApproved", labelKey: "view_tt.filter.dialog.tt_status.approved"},
                {cls: "showReady", labelKey: "view_tt.filter.dialog.tt_status.ready"},
                {cls: "showNotReadyAndRejected", labelKey: "view_tt.filter.dialog.tt_status.not_ready_and_rejected"}
            ]
        }
    }

    activateStatusesSection(isActive) {
        if (!isActive)
        {
            this.setStatuses([WeekApprovalStatus.APPROVED]);
        }
        this.$approved.attr("disabled", !isActive);
        this.$ready.attr("disabled", !isActive);
        this.$notReadyAndRejected.attr("disabled", !isActive);

        this.autoApprovedTooltip.setEnabled(!isActive)
    }

    getStatuses() {
        var weekApprovalStatuses = [];

        if (this.$approved.prop("checked"))
            weekApprovalStatuses.push(WeekApprovalStatus.APPROVED);
        if (this.$ready.prop("checked"))
            weekApprovalStatuses.push(WeekApprovalStatus.READY);
        if (this.$notReadyAndRejected.prop("checked"))
        {
            weekApprovalStatuses.push(WeekApprovalStatus.NOT_READY);
            weekApprovalStatuses.push(WeekApprovalStatus.REJECTED);
        }

        return weekApprovalStatuses;
    }

    setStatuses(statuses) {
        this.$approved.prop("checked", _.contains(statuses, WeekApprovalStatus.APPROVED));
        this.$ready.prop("checked", _.contains(statuses, WeekApprovalStatus.READY));
        this.$notReadyAndRejected.prop("checked", _.contains(statuses, WeekApprovalStatus.NOT_READY) &&
                                                  _.contains(statuses, WeekApprovalStatus.REJECTED));
    }
}



// WEBPACK FOOTER //
// ./web/js/user/viewtt/filter/FilterDialog.js